import MuiDialog from '@mui/material/Dialog';
import SlideTransition from '@/components/SlideTransition';
import CaseCreationCard from '@/components/CaseCreationCard';
import { classes } from './utils';

export type StartCaseDialogProps = {
  onClose: () => void;
};

export default function StartCaseDialog({ onClose }: StartCaseDialogProps) {
  return (
    <MuiDialog
      open
      keepMounted
      disableRestoreFocus
      maxWidth={false}
      PaperProps={{ className: classes.paper }}
      TransitionComponent={SlideTransition}
      onClose={onClose}>
      <CaseCreationCard header={false} onClose={onClose} />
    </MuiDialog>
  );
}
